import { Type } from 'class-transformer';
import type dayjs from 'dayjs';
import type { Direction } from './activity';
import { BaseType, Model } from './model';
import { TransformStringToDayJS } from './utils';

export enum HTTPMethod {
  GET = 'get',
  PATCH = 'patch',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export class HTTPRequest extends BaseType {
  body: Record<string, any> | null;

  headers: Record<string, any> | null;

  method: HTTPMethod;

  params: Record<string, any> | null;

  url: string;
}

export class HTTPResponse extends BaseType {
  body: Record<string, any> | null;

  encoding: string | null;

  headers: Record<string, any> | null;

  reason: string | null;

  status_code: number;
}

export class APIRequestLog extends Model {
  id: string;

  @TransformStringToDayJS()
  completed_at: dayjs.Dayjs;

  direction: Direction;

  @Type(() => HTTPRequest)
  request: HTTPRequest;

  @TransformStringToDayJS()
  requested_at: dayjs.Dayjs;

  @Type(() => HTTPResponse)
  response: HTTPResponse;

  response_size: number;
}
